






































































































import VueOptions from '@utils/VueOptions'
import RequestButton from '@/components/RequestButton'

settings =
  name: 'OrganizerResourceListFilters'

  vue:
    props: ['filters', 'actions']
    components: { RequestButton }

    methods:
      buttonTypeForFilter: (scope, key, attr) ->
        return 'primary' if @filters[scope][key] is attr
        return 'text'

      hiToggleFilter: (scope, key, attr) ->
        if @filters[scope][key] is attr
          @filters[scope][key] = null
        else
          @filters[scope][key] = attr
        
        @actions.hiFilterChange(@selectedFilters())
      
      hiClearSpecificFilter: (key) ->
        @filters.scopes[key] = null
        @actions.hiFilterChange(@selectedFilters())
      
      selectedFilters: ->
        scopes = @filters.scopes
        valid_scopes = []

        Object.keys(scopes).forEach((key) ->
          value = scopes[key]
          if !value
            return false

          name = value.split('_').map((word) -> word.charAt(0).toUpperCase() + word.slice(1)).join(' ')
          valid_scopes.push({ key, value, name })
        )

        filter_data = {}
        for field, timeWindow of @filters.time_windows
          filter_data["#{field}_before"] = timeWindow.before if timeWindow.before
          filter_data["#{field}_after"] = timeWindow.after if timeWindow.after
        filters = JSON.stringify(filter_data)

        return valid_scopes

export default VueOptions.vue settings
